<template>
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="33"
      height="33"
      rx="16.5"
      stroke="#D5CCC9"
    />
    <mask
      id="mask0_38_860"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="32"
      height="32"
    >
      <circle
        cx="17"
        cy="17"
        r="16"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_38_860)">
      <path
        d="M-1 1H35V33H-1"
        fill="#CE1126"
      />
      <path
        d="M-1 1H23V33H-1"
        fill="white"
      />
      <path
        d="M-1 1H11V33H-1"
        fill="#002654"
      />
    </g>
  </svg>
</template>
